import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '../../../utils/shadcn';

const badgeVariants = cva(
  'block items-center rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'hover:bg-primary/80 border-transparent bg-primary text-primary-foreground',
        secondary: 'hover:bg-secondary/80 border-transparent bg-secondary text-muted-foreground',
        destructive: 'hover:bg-destructive/80 border-transparent bg-destructive text-background',
        success: 'bg-green-600 text-background border-transparent hover:bg-green-600/90',
        outline: 'text-muted',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
